'use strict';

var FlightDateRangeLevelChartFilterFactory = function FlightDateRangeLevelChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightCabinFilterFactory', 'FlightDOWFilterFactory', 'FlightSeasonFilterFactory', 'FlightLegFilterFactory', 'FlightLevelFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FlightDateRangeLevelChartFilter() {
    DemandFilter.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'date-range-level-chart');
    this.registerFilters(injectedFilters);
  }
  FlightDateRangeLevelChartFilter.prototype = Object.create(DemandFilter.prototype);
  FlightDateRangeLevelChartFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  return FlightDateRangeLevelChartFilter;
};
FlightDateRangeLevelChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FlightDateRangeLevelChartFilterFactory;